import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation, } from "react-router-dom";
import "../assets/css/DailyDataAnalytics.css";

// Analytics components
import DailyDataAnalytics from "../Components/Analytics/DailyDataAnalytics";
import CompanyAnalytics from "../Components/Analytics/CompanyAnalytics";
import UsersAnalytics from "../Components/Analytics/UsersAnalytics";
import LeadsAnalytics from "../Components/Analytics/LeadsAnalytics";
import DemoAnalytics from "../Components/Analytics/DemoAnalytics";
import InvoicesAnalytics from "../Components/Analytics/InvoicesAnalytics";
import UserActivityAnalytics from "../Components/Analytics/UserActivityAnalytics";
import TopSearchedAnalytics from "../Components/Analytics/TopSearchedAnalytics";

const Analytics = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isManualScroll = useRef(false);
  const scrollContainerRef = useRef(null);

  const activeTab = location.pathname.split("/")[0] || "analytics";
    const [activeMetric, setActiveMetric] = useState("daily-data");

  // refs for scroll
  const refs = {
    "daily-data": useRef(null),
    companies: useRef(null),
    users: useRef(null),
    activity: useRef(null),
    leads: useRef(null),
    demo: useRef(null),
    invoices: useRef(null),
    "top-searches": useRef(null),
  };

  const metrics = [
    { id: "daily-data", title: "Daily Data", icon: "📊" },
    { id: "companies", title: "Total Companies", icon: "🏢" },
    { id: "users", title: "Total Users", icon: "👥" },
    { id: "activity", title: "User Activities", icon: "⚡" },
    { id: "leads", title: "Total Leads", icon: "📈" },
    { id: "demo", title: "Demos", icon: "🎥" },
    { id: "invoices", title: "Invoices", icon: "📄" },
    { id: "top-searches", title: "Top Searched Terms", icon: "🔍" },
  ];

  // Scroll to section + set active
const handleNavigate = (id) => {
  isManualScroll.current = true;
  setActiveMetric(id);

  const container = scrollContainerRef.current;
  const section = refs[id]?.current;

  if (container && section) {
    const offset =
      document.querySelector(".sticky-metric")?.offsetHeight || 70;

    const top =
      section.offsetTop - offset;

    container.scrollTo({
      top,
      behavior: "smooth",
    });
  }

  setTimeout(() => {
    isManualScroll.current = false;
  }, 700);
};


useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      if (isManualScroll.current) return;

      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          setActiveMetric(entry.target.id);
        }
      });
    },
    {
      root: scrollContainerRef.current, // 🔥 THIS LINE
      threshold: 0.5,
    }
  );

  Object.values(refs).forEach((ref) => {
    if (ref.current) observer.observe(ref.current);
  });

  return () => observer.disconnect();
}, []);



  return (
    <div className="daily-analytics-dashboard">
    {/* 🔝 Top Navigation Tabs — Now STICKY */}
    <div className="daily-data-tabs">
        <button onClick={() => navigate("/analytics")} className={activeTab === "analytics" ? "tab-btn active" : "tab-btn"}>
        Analytics
      </button>
      <button onClick={() => navigate("/daily-data-table")} className={activeTab === "daily-data-table" ? "tab-btn active" : "tab-btn"}>
        Daily Data table
      </button>
    
      <button onClick={() => navigate("/dashboard/companies")} className={activeTab === "dashboard" ? "tab-btn active" : "tab-btn"}>
        Dashboard
      </button>
    </div>

   <div className="metric-bar sticky-metric">
  {metrics.map((item) => (
    <div
      key={item.id}
      className={`metric-tab ${activeMetric === item.id ? "active" : ""}`}
      onClick={() => handleNavigate(item.id)}
    >
      <p className="metric-title">{item.title}</p>
    </div>
  ))}
</div>

      <div className="metric-separator" />

      {/* 📜 Scrollable Analytics Content */}
      <div className="content-area" ref={scrollContainerRef}>
        <section id="daily-data" ref={refs["daily-data"]}>
  <DailyDataAnalytics />
</section>

<section id="companies" ref={refs.companies}>
  <CompanyAnalytics />
</section>

<section id="users" ref={refs.users}>
  <UsersAnalytics />
</section>

<section id="activity" ref={refs.activity}>
  <UserActivityAnalytics />
</section>

<section id="leads" ref={refs.leads}>
  <LeadsAnalytics />
</section>

<section id="demo" ref={refs.demo}>
  <DemoAnalytics />
</section>

<section id="invoices" ref={refs.invoices}>
  <InvoicesAnalytics />
</section>

<section id="top-searches" ref={refs["top-searches"]}>
  <TopSearchedAnalytics />
</section>

      </div>
    </div>
  );
};

export default Analytics;
